import React from 'react';
import PolicyLayout from '../components/PolicyLayout';

export default function CookiePolicy() {
  return (
    <PolicyLayout title="Cookie Policy" updated="December 15, 2025">
      <p>
        Our website uses cookies and similar technologies to provide essential features, remember preferences, and analyze
        how the site is used. This Cookie Policy explains what cookies we use and how you can control them.
      </p>

      <div>
        <h3>What Are Cookies?</h3>
        <p>
          Cookies are small text files stored on your device by your browser. They allow sites to remember your preferences
          and provide a better experience.
        </p>
      </div>

      <div>
        <h3>Cookies We Use</h3>
        <ul>
          <li><strong>Essential:</strong> Required for basic functionality such as session management and security.</li>
          <li><strong>Performance &amp; Analytics:</strong> Provide insights into site usage (for example Google Analytics cookies like _ga, _gid) and help us improve performance.</li>
          <li><strong>Functional:</strong> Remember settings like language, timezone, or display preferences.</li>
          <li><strong>Advertising:</strong> May be used to deliver relevant ads or measure ad campaign performance; these may be set by third parties.</li>
        </ul>
      </div>

      <div>
        <h3>Third-Party Cookies</h3>
        <p>
          We may allow third parties (analytics providers, advertising partners, and payment processors) to set cookies on
          our site. These third parties have their own policies and control mechanisms.
        </p>
      </div>

      <div>
        <h3>How to Manage Cookies</h3>
        <p>
          You can control or delete cookies via your browser settings. Disabling certain cookies may limit site
          functionality. For analytics or advertising opt-outs, you can use providers' opt-out tools such as the{' '}
          <a href="https://tools.google.com/dlpage/gaoptout">Google Analytics opt-out</a>.
        </p>
      </div>

      <div>
        <h3>Changes to This Policy</h3>
        <p>
          We may update this policy occasionally; material changes will be posted with a revised "Last updated" date. Your
          continued use after changes constitutes acceptance.
        </p>
      </div>
    </PolicyLayout>
  );
}
